import { pb } from '../../../shared/api/pocketbase';
import type { FetchOptionsResult } from '../../../shared/ui/Select';
import type { SmsTemplate } from './types';

export const fetchSmsTemplateOptions = async ({ page, search }: { page: number; search: string }): Promise<FetchOptionsResult> => {
  const perPage = 20;
  const safeSearch = search.replace(/"/g, '');
  const result = await pb.collection('sms_templates').getList<SmsTemplate>(page, perPage, {
    sort: 'name',
    filter: safeSearch ? `name ~ "${safeSearch}"` : '',
    fields: 'id,name',
    requestKey: null,
  });
  return {
    items: result.items.map(t => ({ value: t.id, label: t.name })),
    hasMore: page * perPage < result.totalItems,
  };
};
